<template>
  <div
    class="flex flex-col gap-8"
  >
    <div
      v-if="props.nPages > 0"
      class="flex flex-row gap-4 mx-auto"
    >
      <NuxtLink
        :to="props.page === 0 ? undefined : { ...route, query: { ...route.query, page: props.page+1 - 1 } }"
        class="bg-secondary hover:bg-secondary-highlighted active:bg-secondary-selected
          aria-disabled:bg-gray-400 aria-disabled:hover:bg-gray-400 aria-disabled:active:bg-gray-400
          text-white text-center rounded-md w-10 h-10 p-2 flex justify-center items-center"
        :title="t('jc.component.paged.prevButton.title')"
        :aria-disabled="props.page === 0"
      >
        <font-awesome-icon
          icon="arrow-left"
          class="h-[1.2em] w-[1.2em]"
        />
      </NuxtLink>

      <template
        v-for="num in pageNumbers"
        :key="num"
      >
        <NuxtLink
          :to="{ ...route, query: { ...route.query, page: num+1 } }"
          class="bg-secondary hover:bg-secondary-highlighted active:bg-secondary-selected
          aria-selected:bg-primary aria-selected:hover:bg-primary-highlighted aria-selected:active:bg-primary-selected
          text-white text-center rounded-md w-10 h-10 p-2 flex justify-center items-center font-semibold"
          :title="t('jc.component.paged.numButton.title', { page: num+1 })"
          :aria-selected="props.page === num"
        >
          {{ t('jc.component.paged.numButton.label', { page: num+1 }) }}
        </NuxtLink>
      </template>

      <NuxtLink
        :to="page === maxPage ? undefined : { ...route, query: { ...route.query, page: props.page+1 + 1 } }"
        class="bg-secondary hover:bg-secondary-highlighted active:bg-secondary-selected
          aria-disabled:bg-gray-400 aria-disabled:hover:bg-gray-400 aria-disabled:active:bg-gray-400
          text-white text-center rounded-md w-10 h-10 p-2 flex justify-center items-center"
        :title="t('jc.component.paged.nextButton.title')"
        :aria-disabled="props.page === maxPage"
      >
        <font-awesome-icon
          icon="arrow-right"
          class="h-[1.2em] w-[1.2em]"
        />
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const { t } = useI18n()
const route = useRoute()

const props = defineProps<{
  page: number
  nPages: number
  nPageNumbers?: number // how many numbers to show
}>()

const maxPage = computed(() => Math.max(0, props.nPages - 1))
const nPageNumbers = computed(() => Math.min(props.nPageNumbers || 4, props.nPages))

const pageNumbers = computed(() => {
  const half = Math.floor(nPageNumbers.value / 2.0)
  const lowerUnbound = props.page - half
  const upperUnbound = props.page + half - (nPageNumbers.value % 2 === 0 ? 1 : 0)

  const lowerDelta = Math.max(0, -lowerUnbound)
  const upperDelta = Math.min(0, maxPage.value - upperUnbound)

  return [...(Array(nPageNumbers.value).keys())].map(n => n + lowerUnbound).map(n => n + lowerDelta + upperDelta)
})
</script>
